import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!./spreadsheetProcessorResult.html';
import controller from './spreadsheetProcessorResultCtrl';
import styles from './spreadsheetProcessorResult-hashed.scss';

var hashedTemplate = cssUtil.hashTemplate(template, styles);

/**
 * @ngdoc component
 * @name gw-spreadsheet-processor-result
 *
 * @description  A component to process the result of spreadsheet upload for CP and BOP buildings during policy transaction
 *
 */
export default {
    controller: controller,
    template: hashedTemplate,
    transclude: true,
    bindings: {
        resultData: '<',
        processor: '<'
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-policytransaction-common-angular/components/spreadsheetProcessorResult/index.js
// module id = 1847
// module chunks = 0